import "./App.css";
import Homepage from "./pages/Homepage";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import "./styles/style.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EntryPage from "./pages/EntryPage";
import { useEffect } from "react";
import RegisterUser from "./pages/RegisterUser";
import LoginPage from "./pages/LoginPage";
import NotFound from "./pages/NotFound";
import { Authentication } from "./useAuth";
import UserRoles from "./pages/UserRoles";
import { ProfilePage } from "./pages/ProfilePage";
import RegisterEntity from "./pages/RegisterEntity";
import AddNewShop from "./pages/Application/AddNewShop";
import ShopList from "./pages/Application/ShopList";
import ShopDetails from "./pages/Application/ShopDetails";
import AddNewUser from "./pages/AddNewUser";
import UserList from "./pages/UserList";
import Auction from "./pages/Application/Auction";
import CurrentAuction from "./pages/Application/CurrentAuction";
import EditShopDetails from "./pages/Application/EditShopDetails";
import AuctionReport from "./pages/Application/AuctionReport";
import UserRejectedList from "./pages/Application/UserRejectedList";
import UserDetails from "./pages/Application/UserDetails";
import BidDetails from "./pages/Application/BidDetails";
import VerifyDemandDraft from "./pages/Application/VerifyDemandDraft";

function App() {
  const Scroll = (props) => {
    const location = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);
    return props.children;
  };
  return (
    <BrowserRouter>
      <ToastContainer position="top-right" />
      <Authentication>
        <Scroll>
          <Routes>
            <Route path="login" element={<LoginPage />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/" element={<Navigate to="/my" />} />
            <Route path="/my" element={<EntryPage />}>
              <Route path="" element={<Navigate to="home" />} />
              <Route path="home" element={<Homepage />} />
              <Route path="registerUser" element={<RegisterUser />} />
              <Route path="userRoles" element={<UserRoles />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="registerEntity" element={<RegisterEntity />} />
              <Route path="addNewShop" element={<AddNewShop />} />
              <Route path="shopList" element={<ShopList />} />
              <Route path="shopDetails" element={<ShopDetails />} />
              <Route path="addNewUser" element={<AddNewUser />} />
              <Route path="userList" element={<UserList />} />
              <Route path="auction" element={<Auction />} />
              <Route path="currentAuction" element={<CurrentAuction />} />
              <Route path="editShopDetails" element={<EditShopDetails />} />
              <Route path="auctionReport" element={<AuctionReport />} />
              <Route path="userRejectedList" element={<UserRejectedList />} />
              <Route path="userDetails" element={<UserDetails />} />
              <Route path="bidDetails" element={<BidDetails />} />
              <Route path="verifyDemandDraft" element={<VerifyDemandDraft />} />

            </Route>
          </Routes>
        </Scroll>
      </Authentication>
    </BrowserRouter>
  );
}

export default App;
